export default __webpack_public_path__ + "static/media/WebsiteProfilePic.ed396dd5.png";